import axios from "axios";
import apiURI from "../Api";

export default class AreaManagerService {
  async postRegisterAreaManager(
    referee,
    username,
    email,
    documentNumber,
    fname,
    lname,
    password,
    currency,
    language,
    transactionID,
    country,
    internationalCode,
    localCode,
    phoneNumber,
    latitude,
    longitude,
    voucher = null,
    paymentMethod = null,
    transferbankReceipt = null,
    association = false,
    documentAssociation = null,
  ) {
    const areamanagerData = {
      documentNumber: null,
      email: email,
      firstname: fname,
      password: password,
      surname: lname,
      language: language,
      country: country,
      internationalCode: internationalCode,
      localCode: localCode,
      phoneNumber: phoneNumber,
      originRegister: JSON.parse(localStorage.getItem("__extraconomy_ismobile__"))
        ? "MOBILE"
        : "WEB",
    };

    if (username !== null && username !== undefined) {
      areamanagerData.username = username;
    }

    const registerAreaManager = {
      transferbankReceipt: transferbankReceipt,
      currency: currency,
      areamanager: areamanagerData,
      association: association,
      latitude: typeof latitude === "string" ? parseFloat(latitude) : latitude,
      longitude: typeof longitude === "string" ? parseFloat(longitude) : longitude,
      paymentGateway: {
        id: 1,
      },
      paymentMethod: {
        id: paymentMethod ? paymentMethod : voucher ? 2 : 1,
      },
      paymenttransactionID: voucher ? voucher : transactionID,
      plan: {
        id: 2,
      },
      referee: {
        username: referee,
      },
    };

    if (documentAssociation) {
      registerAreaManager.documentAssociation = documentAssociation;
    }

    const response = await axios.post(`${apiURI}/areamanager/register`, registerAreaManager);
    return response.data;
  }

  async getCheckPhoneNumber(internationalCode, localCode, phoneNumber) {
    const response = await axios.get(
      `${apiURI}/user/checkphonenumber/ddi/${internationalCode}/ddd/${localCode}/phonenumber/${phoneNumber}`,
    );
    return response.data;
  }

  async getConfirmPhoneNumber(code, numberId) {
    const response = await axios.get(`${apiURI}/user/confirmphonenumber/${numberId}/code/${code}`);
    return response.data;
  }

  async upgrade(token, username, transactionID, hasVoucher) {
    const bodyJson = {
      paymentGateway: { id: 1 },
      paymentMethod: { id: hasVoucher ? 2 : 1 },
      paymenttransactionID: transactionID,
      plan: { id: 2 },
      username: username,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/areamanager/upgrade`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }
}
